<template>
  <div>
    <h2 class="display-1 mt-5"> {{ $t('calendar.heading') }} </h2>

    <div
      id="calendar"
      :class="{ loading }"
    >
      <v-progress-circular
        v-if="loading"
        size="70"
        width="5"
        indeterminate
        color="primary"
        class="center"
      ></v-progress-circular>
      <v-row class="fill-height">
        <v-col>
          <v-sheet height="64">
            <v-toolbar
              flat
              class="overflow-fix"
            >

              <v-btn
                fab
                text
                small
                color="primary"
                @click="prev"
              >
                <v-icon small>
                  mdi-chevron-left
                </v-icon>
              </v-btn>
              <v-toolbar-title
                v-if="$refs.calendar"
                class="mx-3"
              >
                {{ $refs.calendar.title }}
              </v-toolbar-title>
              <v-btn
                fab
                text
                small
                color="primary"
                @click="next"
              >
                <v-icon small>
                  mdi-chevron-right
                </v-icon>
              </v-btn>
              <v-spacer></v-spacer>
              <div>

                <v-btn
                  outlined
                  class="mr-4 "
                  color="grey darken-2"
                  @click="setToday"
                >
                  {{ $t('calendar.today') }}
                  <!-- i18n -->
                </v-btn>
                <v-menu
                  bottom
                  right
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      outlined
                      color="grey darken-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <span>{{ typeToLabel[type] }}</span>
                      <v-icon right>
                        mdi-menu-down
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="type = 'day'">
                      <v-list-item-title> {{ $t('calendar.day') }} </v-list-item-title> <!-- i18n -->
                    </v-list-item>
                    <v-list-item @click="type = 'week'">
                      <v-list-item-title> {{ $t('calendar.week') }} </v-list-item-title> <!-- i18n -->
                    </v-list-item>
                    <v-list-item @click="type = 'month'">
                      <v-list-item-title> {{ $t('calendar.month') }} </v-list-item-title> <!-- i18n -->
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </v-toolbar>
          </v-sheet>
          <v-sheet height="600" class="pt-6 pt-sm-0">
            <v-calendar
              ref="calendar"
              v-model="focus"
              color="primary"
              :events="events"
              :event-color="getEventColor"
              :type="type"
              :weekdays="weekdays"
              @click:event="showEvent"
              @click:more="viewDay"
              @click:date="viewDay"
            ></v-calendar>
            <v-menu
              v-model="selectedOpen"
              :close-on-content-click="false"
              :activator="selectedElement"
              offset-x
            >
              <v-card
                color="grey lighten-4"
                max-width="350px"
                flat
              >
                <v-toolbar
                  :color="selectedEvent.color"
                  dark
                >
                  <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn
                    icon
                    @click="selectedOpen = false"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-card-text>
                  <span>{{ selectedEvent.description}}</span>
                </v-card-text>
                <v-card-actions v-if="selectedEvent">
                  <!-- i18n -->
                  <v-btn
                    text
                    color="primary"
                    :to="`/${selectedEvent.errandId}`"
                  >
                  {{ $t('calendar.goToErrand') }}
                </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </v-sheet>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import repository from '@/core/repository/calendar-repository'

export default {
  data: () => ({
    loading: true,
    focus: '',
    type: 'month',
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
    weekdays: [1, 2, 3, 4, 5, 6, 0]
  }),
  mounted() {
    this.getTasks()
  },
  computed: {
    typeToLabel() {
      return {
        month: this.$t('calendar.month'),
        week: this.$t('calendar.week'),
        day: this.$t('calendar.day')
      }
    }
  },
  methods: {
    viewDay({ date }) {
      this.focus = date
      this.type = 'day'
    },
    getEventColor(event) {
      return event.color
    },
    setToday() {
      this.focus = ''
    },
    prev() {
      this.$refs.calendar.prev()
    },
    next() {
      this.$refs.calendar.next()
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        setTimeout(() => {
          this.selectedOpen = true
        }, 10)
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        setTimeout(open, 10)
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    },
    getTasks() {
      this.loading = true
      repository
        .getUpcomingTasks()
        .done(tasks => {
          this.events = tasks
          this.loading = false
        })
        .always(() => (this.loading = false))
    }
  }
}
</script>

<style lang="scss" scoped>
// Might be used if we can get the flex-wrap: wrap to work (WIP) on the .v-toolbar__content
// .v-sheet.theme--light.v-toolbar.v-toolbar--flat {
//   height: auto !important;
// }
.loading {
  color: color(white);
  opacity: 0.3;
  pointer-events: none;
}
.center {
  position: absolute;
  display: block;
  left: 45%;
  top: 45%;
  z-index: 99;
}
</style>
